// extracted by mini-css-extract-plugin
module.exports = {"chatTip":"ChatTip_chatTip__XBuCC","anchor":"ChatTip_anchor__2CzV3"};